// import { useState, useEffect, useCallback, useRef } from 'react';
// import axios from 'axios';
// import { Link, useLocation } from 'react-router-dom';
// import {
//     Box, Grid, Paper, Typography, IconButton, Snackbar, Alert, Tooltip, Card,
//     CardContent, Checkbox, useMediaQuery, useTheme, Divider, Chip, CircularProgress,
//     TextField, InputAdornment, Dialog, Button, DialogTitle, DialogContent, DialogActions,
// } from '@mui/material';
// import { VscNewFile } from "react-icons/vsc";
// import { FaFileExcel } from 'react-icons/fa';
// import DeleteIcon from '@mui/icons-material/Delete';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import SearchIcon from '@mui/icons-material/Search';
// import { useAuth } from '../context/AuthContext';
// import CommonServerDataGrid from '../components/datagridComponent';
// import { formatRows } from '../utils/formatRows';
// import NoDataComponent from '../components/NoDataComponent';
// import CenterLoader from './Test/components/CenterLoader';
// import CustomNoDataOverlay from '../components/CustomNoDataOverlay';
// import { APPBAR_HEIGHT } from '../utils/theme';

// /**
//  * ProdGroupDetail2 Component
//  * 
//  * Displays product groups in two views:
//  * - Desktop: CommonServerDataGrid component with pagination, filtering, sorting
//  * - Mobile: Card view with search and pagination
//  * 
//  * Features:
//  * - Server-side pagination, filtering, sorting
//  * - Search functionality for mobile view
//  * - Bulk deletion
//  * - Excel export
//  * - Responsive design
//  */
// export default function ProdGroupDetail2({ connectionString }) {
//     const { user, selectedCompany } = useAuth();
//     const userId = user?.UserId || null;
//     const companyId = selectedCompany?.CompId || null;
//     const role = user?.UserCategory;
//     const path = `${connectionString}/api`;

//     const theme = useTheme();
//     const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
//     const isSmallDevice = useMediaQuery(theme.breakpoints.down(500));
//     const [isFiltered, setIsFiltered] = useState(false);

//     // ============ STATE MANAGEMENT ============

//     // Shared state for both views
//     const [rows, setRows] = useState([]);
//     const [totalCount, setTotalCount] = useState(0);
//     const [selectionModel, setSelectionModel] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
//     const [selectAll, setSelectAll] = useState(false);

//     // Desktop state (DataGrid)
//     const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 });
//     const [filterModel, setFilterModel] = useState({ items: [] });
//     const [sortModel, setSortModel] = useState([]);

//     // Mobile state (Search + Pagination)
//     const [mobileSearchQuery, setMobileSearchQuery] = useState('');
//     const [debouncedMobileSearch, setDebouncedMobileSearch] = useState('');
//     const [mobilePaginationModel, setMobilePaginationModel] = useState({ page: 0, pageSize: 20 });

//     const [confirmOpen, setConfirmOpen] = useState(false);
//     const [pendingDeleteIds, setPendingDeleteIds] = useState([]);
//     const selectedIdsRef = useRef([]);

//     console.log('=== COMPONENT RENDER ===');
//     console.log('isSmallScreen:', isSmallScreen);
//     console.log('mobileSearchQuery:', mobileSearchQuery);
//     console.log('debouncedMobileSearch:', debouncedMobileSearch);
//     console.log('rows count:', rows.length);
//     console.log('totalCount:', totalCount);

//     // ============ PARAMETER BUILDERS ============

//     /**
//      * Build parameters for mobile search request
//      */
//     const buildMobileParams = (pageNum, searchText) => {
//         const offset = pageNum * 20;
//         const params = { mode: 'search', userId, companyId, offset, limit: 20 };

//         if (searchText && searchText.trim()) {
//             params.search = searchText; // Send search to backend
//         }

//         console.log('📦 buildMobileParams:', params);
//         return params;
//     };

//     /**
//      * Build parameters for desktop request with filters and sort
//      */
//     const buildDesktopParams = (pageNum, pageSize) => {
//         const offset = pageNum * pageSize;
//         const params = { mode: 'search', userId, companyId, offset, limit: pageSize };

//         // Add filters from DataGrid
//         filterModel.items.forEach(item => {
//             if (item.value) {
//                 switch (item.field) {
//                     case 'GroupName':
//                         params.GroupName = item.value;
//                         break;
//                     case 'GroupCode':
//                         params.GroupCode = item.value;
//                         break;
//                     case 'IsPrimary':
//                         params.IsPrimary = item.value;
//                         break;
//                     case 'UnderGRPName':
//                         params.UnderGRP = item.value;
//                         break;
//                     default:
//                         break;
//                 }
//             }
//         });

//         // Add sorting
//         if (sortModel.length > 0) {
//             const sort = sortModel[0];
//             params.orderBy = `${sort.field} ${sort.sort.toUpperCase()}`;
//         }

//         console.log('🖥️ buildDesktopParams:', params);
//         return params;
//     };

//     // ============ FETCH FUNCTIONS ============

//     /**
//      * Fetch data for desktop view (with filters and sort)
//      */
//     const fetchDataDesktop = useCallback(async () => {
//         if (isSmallScreen) return;

//         console.log('🖥️ [DESKTOP] Fetching data...');
//         setLoading(true);
//         try {
//             const params = buildDesktopParams(paginationModel.page, paginationModel.pageSize);

//             // Fetch rows
//             const dataRes = await axios.get(`${path}/group/search`, { params });
//             const fetchedRows = Array.isArray(dataRes.data) ? dataRes.data : [];
//             setRows(formatRows(fetchedRows));
//             setSelectionModel([]);
//             selectedIdsRef.current = [];
//             console.log("data:", dataRes.data);

//             console.log(`🖥️ Fetched ${fetchedRows.length} rows`);

//             // Fetch total count
//             const countParams = { ...params };
//             delete countParams.mode;
//             delete countParams.offset;
//             delete countParams.limit;
//             delete countParams.orderBy;
//             delete countParams.userId;

//             const countRes = await axios.get(`${path}/group/count`, { params: countParams });
//             const count = Number(countRes.data) || 0;
//             setTotalCount(count);

//             console.log(`🖥️ Total count: ${count}`);
//         } catch (err) {
//             console.error('🖥️ Fetch error:', err);
//             setSnackbar({ open: true, message: 'Failed to fetch data.', severity: 'error' });
//             setRows([]);
//             setTotalCount(0);
//         } finally {
//             setLoading(false);
//         }
//     }, [path, userId, companyId, paginationModel, filterModel, sortModel, isSmallScreen]);

//     /**
//      * Fetch data for mobile view (with search only)
//      */
//     const fetchDataMobile = useCallback(async () => {
//         console.log('📱 [MOBILE] Fetching data...');

//         if (!isSmallScreen) {
//             console.log('📱 Skipping - not small screen');
//             return;
//         }

//         setLoading(true);
//         try {
//             const params = buildMobileParams(mobilePaginationModel.page, debouncedMobileSearch);

//             console.log('📱 API URL:', `${path}/group/search`);
//             console.log('📱 Params:', JSON.stringify(params, null, 2));

//             // Fetch rows
//             const dataRes = await axios.get(`${path}/group/search`, { params });
//             const fetchedRows = Array.isArray(dataRes.data) ? dataRes.data : [];
//             setRows(formatRows(fetchedRows));
//             setSelectionModel([]);
//             selectedIdsRef.current = [];
//             console.log(`📱 Fetched ${fetchedRows.length} rows`);

//             // Fetch total count
//             const countParams = { ...params };
//             delete countParams.mode;
//             delete countParams.offset;
//             delete countParams.limit;
//             delete countParams.userId;

//             console.log('📱 Count params:', countParams);
//             const countRes = await axios.get(`${path}/group/count`, { params: countParams });
//             const count = Number(countRes.data) || 0;
//             setTotalCount(count);

//             console.log(`📱 Total count: ${count}`);
//         } catch (err) {
//             console.error('📱 Fetch error:', err);
//             console.error('📱 Error response:', err.response?.data);
//             setSnackbar({ open: true, message: `Error: ${err.message}`, severity: 'error' });
//             setRows([]);
//             setTotalCount(0);
//         } finally {
//             setLoading(false);
//         }
//     }, [path, userId, companyId, mobilePaginationModel, debouncedMobileSearch, isSmallScreen]);

//     // ============ EFFECTS ============

//     /**
//      * Trigger desktop fetch when pagination, filters, or sort changes
//      */
//     useEffect(() => {
//         console.log('💻 [EFFECT] Desktop dependencies changed');
//         if (!isSmallScreen) {
//             fetchDataDesktop();
//         }
//     }, [paginationModel.page, paginationModel.pageSize, filterModel, sortModel, isSmallScreen, fetchDataDesktop]);

//     /**
//      * Trigger mobile fetch when pagination changes
//      */
//     useEffect(() => {
//         console.log('📱 [EFFECT] Mobile pagination changed:', mobilePaginationModel);
//         if (isSmallScreen) {
//             fetchDataMobile();
//         }
//     }, [mobilePaginationModel.page, mobilePaginationModel.pageSize, isSmallScreen, debouncedMobileSearch]);

//     /**
//      * Debounce mobile search and trigger fetch
//      */
//     useEffect(() => {
//         console.log('⏱️ [DEBOUNCE] Starting 400ms timeout for:', mobileSearchQuery);

//         const timer = setTimeout(() => {
//             console.log('⏱️ [DEBOUNCE] Timer completed! Setting search to:', mobileSearchQuery);
//             setDebouncedMobileSearch(mobileSearchQuery);
//             setMobilePaginationModel({ page: 0, pageSize: 20 });
//         }, 400);

//         return () => {
//             console.log('⏱️ [DEBOUNCE] Cleared timeout');
//             clearTimeout(timer);
//         };
//     }, [mobileSearchQuery]);

//     /**
//      * Trigger fetch when debounced search changes
//      */
//     // useEffect(() => {
//     //     console.log('📱 [EFFECT] Debounced search changed:', debouncedMobileSearch);
//     //     if (isSmallScreen) {
//     //         fetchDataMobile();
//     //     }
//     // }, [debouncedMobileSearch, isSmallScreen, fetchDataMobile]);

//     // ============ DELETE HANDLER ============

//     const handleDelete = async () => {
//         // if (selectionModel.length === 0) return;
//         const ids = selectedIdsRef.current;
//         if (!ids.length) return;

//         try {
//             const response = await axios.post(`${path}/group/Delete`, { userId, companyId, objAryId: ids });
//             setSnackbar({ open: true, message: 'Deleted successfully.', severity: 'success' });

//             setSelectionModel([]);
//             selectedIdsRef.current = [];
//             setSelectAll(false);

//             // Refetch data
//             if (isSmallScreen) {
//                 fetchDataMobile();
//             } else {
//                 fetchDataDesktop();
//             }
//         } catch (error) {
//             const status = error.response?.status;
//             const data = error.response?.data;
//             const message = error.response?.status === 400 && error.response?.data?.error ? error.response.data.error : 'Delete failed due to an unexpected error.';
//             // 🔴 Case: 400 + referenced IDs (business rule failure)
//             if (status === 400 && data?.referencedIds?.length > 0) {
//                 setSnackbar({ open: true, message: "Cannot delete the selected item(s) because they are referenced in other records.", severity: "warning" });

//             } else if (status === 400 && data?.error) {
//                 // 🔴 400 but no referencedIds array (generic validation)
//                 setSnackbar({ open: true, message: data.error, severity: "warning" });
//             } else {
//                 // 🔴 unexpected / server error
//                 setSnackbar({ open: true, message: "Delete failed due to an unexpected error.", severity: "error" });
//             }
//         } finally {
//             setConfirmOpen(false);
//         }
//     };

//     // ============ EXPORT HANDLER ============

//     const funExportData = () => {
//         axios({ url: `${path}/group/search?mode=export&userId=${userId}&companyId=${companyId}`, method: 'GET', responseType: 'blob', })
//             .then((response) => {
//                 const url = window.URL.createObjectURL(new Blob([response.data]));
//                 const link = document.createElement('a');
//                 link.href = url;
//                 link.setAttribute('download', 'exportedFileProductGroup.xlsx');
//                 document.body.appendChild(link);
//                 link.click();
//                 document.body.removeChild(link);
//             })
//             .catch((error) => {
//                 console.error('Export error:', error);
//                 setSnackbar({ open: true, message: 'Export failed.', severity: 'error' });
//             });
//     };

//     // ============ SELECT ALL TOGGLE ============

//     const toggleSelectAll = () => {
//         if (selectAll) {
//             setSelectionModel([]);
//             selectedIdsRef.current = [];
//             setSelectAll(false);
//         } else {
//             const allIds = rows.map(row => row.ProdGRPID);
//             setSelectionModel(allIds);
//             selectedIdsRef.current = allIds; // 🔥 freeze
//             setSelectAll(true);
//         }
//     };

//     // ============ COLUMNS DEFINITION ============

//     const columns = [
//         {
//             field: 'GroupName', headerName: 'Group Name', flex: 1, minWidth: 150,
//             renderCell: (params) => (
//                 <Typography variant="body1" sx={{ cursor: 'pointer', color: '#1877F2', textDecoration: 'underline', fontSize: '0.85rem' }} onClick={() => window.location.href = `/main/editProGroupMaster/${params.row.ProdGRPID}`} >
//                     {params.value}
//                 </Typography>
//             )
//         },
//         { field: 'GroupCode', headerName: 'Group Code', flex: 0.7, minWidth: 120 },
//         { field: 'IsPrimary', headerName: 'Primary', flex: 0.5, minWidth: 80, valueFormatter: (value) => (value === 1 ? 'True' : 'False'), filterable: false },
//         { field: 'UnderGRPName', headerName: 'Under Group', flex: 1, minWidth: 150 },
//     ];

//     // Add delete button column if not User
//     if (role !== "User") {
//         columns.push({
//             flex: 0.3, minWidth: 80, sortable: false, filterable: false, headerAlign: 'right', align: 'right',
//             renderCell: (params) => {
//                 const isRowSelected = selectionModel.includes(params.row.ProdGRPID);
//                 return (
//                     <Tooltip title={isRowSelected ? "Delete Row" : "Select row to enable"}>
//                         <span>
//                             <IconButton color="error" disabled={!isRowSelected}
//                                 onClick={(e) => {
//                                     e.stopPropagation();
//                                     e.preventDefault();
//                                     selectedIdsRef.current = selectionModel;   // 🔥 SYNC HERE
//                                     setPendingDeleteIds(selectionModel);
//                                     setConfirmOpen(true);
//                                 }}
//                             >
//                                 <DeleteIcon />
//                             </IconButton>
//                         </span>
//                     </Tooltip>
//                 );
//             }
//         });
//     }

//     // ============ CARD RENDERING (MOBILE) ============

//     const renderCards = () => {
//         if (loading) {
//             return (
//                 <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4 }}> <CircularProgress /> </Box>
//             );
//         }

//         if (rows.length === 0) {
//             return (
//                 <Box sx={{ p: 4, textAlign: 'center' }}>
//                     <Typography sx={{ color: 'text.secondary', mb: 2 }}> {mobileSearchQuery ? <CustomNoDataOverlay /> : <NoDataComponent />} </Typography>
//                     <Typography sx={{ color: 'text.secondary', fontSize: '0.85rem' }}> Search: "{debouncedMobileSearch}" | Page: {mobilePaginationModel.page} | Total: {totalCount} </Typography>
//                 </Box>
//             );
//         }

//         return (
//             <>
//                 {rows.map((row) => {
//                     const isSelected = selectionModel.includes(row.ProdGRPID);

//                     const toggleSelection = (e) => {
//                         e.stopPropagation();
//                         setSelectionModel(prev => {
//                             const updated = prev.includes(row.ProdGRPID) ? prev.filter(id => id !== row.ProdGRPID) : [...prev, row.ProdGRPID]
//                             selectedIdsRef.current = updated; // 🔥 freeze selection
//                             return updated;
//                         })
//                     };

//                     return (
//                         <Card key={row.ProdGRPID} sx={{ mb: 1.5, boxShadow: 3, borderRadius: 2, overflow: 'hidden', transition: '0.2s', '&:hover': { boxShadow: 5 }, borderLeft: '4px solid', borderLeftColor: 'primary.main', cursor: 'pointer' }} onClick={() => window.location.href = `/main/editProGroupMaster/${row.ProdGRPID}`} >
//                             <CardContent sx={{ p: 2, pb: '16px !important' }}>
//                                 <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
//                                     <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
//                                         {role !== 'User' && (
//                                             <Checkbox checked={isSelected} onChange={toggleSelection} onClick={(e) => e.stopPropagation()} size="small" sx={{ mr: 1, p: 0.5 }} />
//                                         )}
//                                         <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1rem', color: 'text.primary' }} >
//                                             {row.GroupName || '—'}
//                                         </Typography>
//                                     </Box>

//                                     <Chip label={row.UnderGRPName || 'N/A'} size="small" sx={{ fontSize: '0.75rem', height: 24, bgcolor: row.IsPrimary === 1 ? 'primary.main' + '20' : 'grey.200', color: row.IsPrimary === 1 ? 'primary.main' : 'text.secondary', border: '1px solid', borderColor: row.IsPrimary === 1 ? 'primary.main' : 'divider' }} />
//                                 </Box>

//                                 <Divider sx={{ my: 1.5 }} />

//                                 <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                                     <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.875rem' }}>
//                                         Code: <strong>{row.GroupCode || '—'}</strong>
//                                     </Typography>

//                                     <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                         <CheckCircleIcon fontSize="small" sx={{ color: row.IsPrimary === 1 ? 'primary.main' : 'text.disabled', mr: 0.5 }} />
//                                         <Typography variant="body2" sx={{ fontSize: '0.875rem', color: row.IsPrimary === 1 ? 'primary.main' : 'text.secondary', fontWeight: row.IsPrimary === 1 ? 600 : 400 }} >
//                                             {row.IsPrimary === 1 ? 'Primary' : 'Non-Primary'}
//                                         </Typography>
//                                     </Box>
//                                 </Box>
//                             </CardContent>
//                         </Card>
//                     );
//                 })}

//                 {/* Mobile Pagination Controls */}
//                 <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, py: 2, mt: 2 }}>
//                     <button onClick={() => setMobilePaginationModel(p => ({ ...p, page: Math.max(0, p.page - 1) }))} disabled={mobilePaginationModel.page === 0} style={{ padding: '8px 12px', cursor: mobilePaginationModel.page === 0 ? 'not-allowed' : 'pointer', opacity: mobilePaginationModel.page === 0 ? 0.5 : 1, border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#f5f5f5', }} >
//                         ← Previous
//                     </button>

//                     <Typography variant="body2" sx={{ minWidth: '150px', textAlign: 'center' }}>
//                         Page {mobilePaginationModel.page + 1} of {Math.ceil(totalCount / mobilePaginationModel.pageSize) || 1}
//                     </Typography>

//                     <button onClick={() => setMobilePaginationModel(p => ({ ...p, page: p.page + 1 }))} disabled={(mobilePaginationModel.page + 1) * mobilePaginationModel.pageSize >= totalCount} style={{ padding: '8px 12px', cursor: (mobilePaginationModel.page + 1) * mobilePaginationModel.pageSize >= totalCount ? 'not-allowed' : 'pointer', opacity: (mobilePaginationModel.page + 1) * mobilePaginationModel.pageSize >= totalCount ? 0.5 : 1, border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#f5f5f5', }} >
//                         Next →
//                     </button>
//                 </Box>
//             </>
//         );
//     };

//     // ============ RENDER ============

//     return (
//         <Box sx={{
//             pt: 0.7, px: { xs: 2, sm: 3, md: 4 }, display: 'flex',
//             flexDirection: 'column', height: `calc(100vh - ${APPBAR_HEIGHT}px)`,
//         }}>
//             {/* Toolbar */}

//             <Box sx={{ position: 'relative', mb: 0.7 }}>
//                 {/* Icons - Absolute positioned on the left */}
//                 <Box sx={{ position: 'absolute', left: 0, top: '50%', transform: 'translateY(-50%)', display: 'flex', gap: 0.3, zIndex: 1 }}>
//                     <Tooltip title="Add New Product Group">
//                         <IconButton component={Link} to="/main/proGroupMaster" sx={{ color: "orange" }}>
//                             <VscNewFile size={25} />
//                         </IconButton>
//                     </Tooltip>
//                     <Tooltip title="Export to Excel">
//                         <IconButton onClick={funExportData} color="success">
//                             <FaFileExcel size={22} />
//                         </IconButton>
//                     </Tooltip>
//                 </Box>

//                 {/* Title - Centered */}
//                 <Typography variant="h5" sx={{ textAlign: 'center', fontSize: { xs: '1.25rem', sm: '1.5rem' }, fontWeight: 600 }} >
//                     {isSmallDevice ? "Product Group" : "Product Group Details"}
//                 </Typography>

//             </Box>

//             {/* Content */}
//             <Paper elevation={3} sx={{ borderRadius: 2, overflow: 'hidden', flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0, marginBottom: "12px" }}>
//                 <Box sx={{ p: { xs: 0.5, md: 0.5 }, display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
//                     {/* Mobile Search Field */}
//                     {isSmallScreen && (
//                         <Box sx={{ mb: 2, px: 1 }}>
//                             <TextField fullWidth size="small" placeholder="Search groups..." value={mobileSearchQuery} onChange={(e) => setMobileSearchQuery(e.target.value)} variant="outlined"
//                                 InputProps={{
//                                     startAdornment: (
//                                         <InputAdornment position="start">
//                                             <SearchIcon />
//                                         </InputAdornment>
//                                     ),
//                                 }}
//                             />
//                         </Box>
//                     )}

//                     {/* Debug Info */}
//                     {/* {isSmallScreen && (
//                         <Box sx={{ mb: 2, p: 1, bgcolor: '#f0f0f0', borderRadius: 1, fontSize: '0.75rem' }}>
//                             <Typography sx={{ fontSize: '0.75rem', color: '#666' }}>
//                                 Debug: Search="{debouncedMobileSearch}" | Page={mobilePaginationModel.page} | Rows={rows.length} | Total={totalCount} | Loading={loading ? 'Yes' : 'No'}
//                             </Typography>
//                         </Box>
//                     )} */}

//                     {/* Bulk Action Bar - Mobile Only */}
//                     {isSmallScreen && role !== 'User' && selectionModel.length > 0 && (
//                         <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5, mb: 2, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 1 }} >
//                             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                 <Checkbox checked={selectAll} onChange={toggleSelectAll} size="small" />
//                                 <Typography variant="body2" sx={{ ml: 1 }}>
//                                     {selectionModel.length} selected
//                                 </Typography>
//                             </Box>
//                             <Tooltip title="Delete selected">
//                                 <IconButton onClick={(e) => {
//                                     e.stopPropagation();
//                                     e.preventDefault();
//                                     selectedIdsRef.current = selectionModel;   // 🔥 SYNC HERE
//                                     setPendingDeleteIds(selectionModel);
//                                     setConfirmOpen(true);
//                                 }} color="error">
//                                     <DeleteIcon />
//                                 </IconButton>
//                             </Tooltip>
//                         </Box>
//                     )}

//                     {/* Mobile View - Cards */}
//                     {isSmallScreen ? (
//                          <Box sx={{ width: '100%', overflowX: 'hidden', px: 1, flex: 1, overflowY: 'auto'}}>
//                             {renderCards()}
//                         </Box>
//                     ) : (
//                         /* Desktop View - CommonServerDataGrid */
//                          <Box sx={{ flex: 1, width: '100%', minHeight: 0 }}>
//                             {
//                                 rows?.length === 0 && !isFiltered ? (
//                                     <NoDataComponent />
//                                 ) : (
//                                     <CommonServerDataGrid data={rows} columns={columns} getRowId={(row) => row.ProdGRPID} role={role} pageSizeOptions={[25, 50, 100]} selectionModel={selectionModel} onSelectionModelChange={setSelectionModel} onPageChange={({ page, pageSize }) => { setPaginationModel({ page, pageSize }); }} onFilterChange={setFilterModel} onSortChange={setSortModel} rowCount={totalCount} onFilterStatusChange={setIsFiltered} />
//                                 )
//                             }

//                         </Box>
//                     )}
//                 </Box>
//             </Paper>

//             {/* Snackbar */}
//             <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} >
//                 <Alert severity={snackbar.severity} variant="filled">
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>

//             <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)} maxWidth="xs" fullWidth >
//                 <DialogTitle>Confirm Deletion</DialogTitle>

//                 <DialogContent>
//                     <Typography variant="body2">
//                         Are you sure you want to delete{' '}
//                         <strong>{pendingDeleteIds.length}</strong> HSN record(s)?
//                     </Typography>
//                 </DialogContent>

//                 <DialogActions>
//                     <Button onClick={() => setConfirmOpen(false)} variant='outlined'> Cancel </Button>
//                     <Button color="error" variant="contained" onClick={handleDelete} > Delete </Button>
//                 </DialogActions>
//             </Dialog>
//         </Box>
//     );
// }





// import { useState, useEffect, useCallback, useRef } from 'react';
// import { Box, Button, CircularProgress, IconButton, Tooltip, Dialog, Snackbar, Alert, DialogTitle, DialogContent, DialogActions, Typography, Checkbox, InputAdornment, TextField, Chip, Divider } from '@mui/material';
// import AddIcon from '@mui/icons-material/Add';
// import DeleteIcon from '@mui/icons-material/Delete';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import SearchIcon from '@mui/icons-material/Search';
// import axios from 'axios';
// import { Link } from 'react-router-dom';
// import { useAuth } from '../context/AuthContext';
// import CustomNoDataOverlay from '../components/CustomNoDataOverlay';
// import NoDataComponent from '../components/NoDataComponent';
// import { useTheme, useMediaQuery } from '@mui/material';
// import CommonServerDataGrid from '../components/datagridComponent';
// import { formatRows } from '../utils/formatRows';
// import { FaFileExcel } from 'react-icons/fa';
// import ProGroupMaster from './ProGroupMaster';

// const ProdGroupDetail2 = ({ connectionString, companyId, mode, setMode }) => {
//     const { user, selectedCompany } = useAuth();
//     const userId = user?.UserId || null;
//     const role = user?.UserCategory;
//     const path = `${connectionString}/api`;

//     const theme = useTheme();
//     const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
//     const isSmallDevice = useMediaQuery(theme.breakpoints.down(500));

//     // ================= STATE =================
//     const [rows, setRows] = useState([]);
//     const [totalCount, setTotalCount] = useState(0);
//     const [selectionModel, setSelectionModel] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
//     const [selectAll, setSelectAll] = useState(false);

//     // Desktop state (DataGrid)
//     const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 });
//     const [filterModel, setFilterModel] = useState({ items: [] });
//     const [sortModel, setSortModel] = useState([]);
//     const [isFiltered, setIsFiltered] = useState(false);

//     // Mobile state (Search + Pagination)
//     const [mobileSearchQuery, setMobileSearchQuery] = useState('');
//     const [debouncedMobileSearch, setDebouncedMobileSearch] = useState('');
//     const [mobilePaginationModel, setMobilePaginationModel] = useState({ page: 0, pageSize: 20 });
//     const [openDialog, setOpenDialog] = useState(false);
//     const [editingId, setEditingId] = useState(null);

//     const [confirmOpen, setConfirmOpen] = useState(false);
//     const [pendingDeleteIds, setPendingDeleteIds] = useState([]);
//     const selectedIdsRef = useRef([]);

//     // ================= PARAMETER BUILDERS =================

//     /**
//      * Build parameters for mobile search request
//      */
//     const buildMobileParams = (pageNum, searchText) => {
//         const offset = pageNum * 20;
//         const params = { mode: 'search', userId, companyId, offset, limit: 20 };

//         if (searchText && searchText.trim()) {
//             params.search = searchText;
//         }

//         console.log('📦 buildMobileParams:', params);
//         return params;
//     };

//     /**
//      * Build parameters for desktop request with filters and sort
//      */
//     const buildDesktopParams = (pageNum, pageSize) => {
//         const offset = pageNum * pageSize;
//         const params = { mode: 'search', userId, companyId, offset, limit: pageSize };

//         filterModel.items.forEach(item => {
//             if (item.value) {
//                 switch (item.field) {
//                     case 'GroupName':
//                         params.GroupName = item.value;
//                         break;
//                     case 'GroupCode':
//                         params.GroupCode = item.value;
//                         break;
//                     case 'IsPrimary':
//                         params.IsPrimary = item.value;
//                         break;
//                     case 'UnderGRPName':
//                         params.UnderGRP = item.value;
//                         break;
//                     default:
//                         break;
//                 }
//             }
//         });

//         if (sortModel.length > 0) {
//             const sort = sortModel[0];
//             params.orderBy = `${sort.field} ${sort.sort.toUpperCase()}`;
//         }

//         console.log('🖥️ buildDesktopParams:', params);
//         return params;
//     };

//     // ================= FETCH FUNCTIONS =================

//     /**
//      * Fetch data for desktop view (with filters and sort)
//      */
//     const fetchDataDesktop = useCallback(async () => {
//         if (isSmallScreen) return;

//         console.log('🖥️ [DESKTOP] Fetching data...');
//         setLoading(true);
//         try {
//             const params = buildDesktopParams(paginationModel.page, paginationModel.pageSize);

//             const dataRes = await axios.get(`${path}/group/search`, { params });
//             const fetchedRows = Array.isArray(dataRes.data) ? dataRes.data : [];
//             setRows(formatRows(fetchedRows));
//             setSelectionModel([]);
//             selectedIdsRef.current = [];
//             console.log(`🖥️ Fetched ${fetchedRows.length} rows`);

//             const countParams = { ...params };
//             delete countParams.mode;
//             delete countParams.offset;
//             delete countParams.limit;
//             delete countParams.orderBy;
//             delete countParams.userId;

//             const countRes = await axios.get(`${path}/group/count`, { params: countParams });
//             const count = Number(countRes.data) || 0;
//             setTotalCount(count);

//             console.log(`🖥️ Total count: ${count}`);
//         } catch (err) {
//             console.error('🖥️ Fetch error:', err);
//             setSnackbar({ open: true, message: 'Failed to fetch data.', severity: 'error' });
//             setRows([]);
//             setTotalCount(0);
//         } finally {
//             setLoading(false);
//         }
//     }, [path, userId, companyId, paginationModel, filterModel, sortModel, isSmallScreen]);

//     /**
//      * Fetch data for mobile view (with search only)
//      */
//     const fetchDataMobile = useCallback(async () => {
//         console.log('📱 [MOBILE] Fetching data...');

//         if (!isSmallScreen) {
//             console.log('📱 Skipping - not small screen');
//             return;
//         }

//         setLoading(true);
//         try {
//             const params = buildMobileParams(mobilePaginationModel.page, debouncedMobileSearch);

//             console.log('📱 API URL:', `${path}/group/search`);
//             console.log('📱 Params:', JSON.stringify(params, null, 2));

//             const dataRes = await axios.get(`${path}/group/search`, { params });
//             const fetchedRows = Array.isArray(dataRes.data) ? dataRes.data : [];
//             setRows(formatRows(fetchedRows));
//             setSelectionModel([]);
//             selectedIdsRef.current = [];
//             console.log(`📱 Fetched ${fetchedRows.length} rows`);

//             const countParams = { ...params };
//             delete countParams.mode;
//             delete countParams.offset;
//             delete countParams.limit;
//             delete countParams.userId;

//             console.log('📱 Count params:', countParams);
//             const countRes = await axios.get(`${path}/group/count`, { params: countParams });
//             const count = Number(countRes.data) || 0;
//             setTotalCount(count);

//             console.log(`📱 Total count: ${count}`);
//         } catch (err) {
//             console.error('📱 Fetch error:', err);
//             console.error('📱 Error response:', err.response?.data);
//             setSnackbar({ open: true, message: `Error: ${err.message}`, severity: 'error' });
//             setRows([]);
//             setTotalCount(0);
//         } finally {
//             setLoading(false);
//         }
//     }, [path, userId, companyId, mobilePaginationModel, debouncedMobileSearch, isSmallScreen]);

//     // ================= EFFECTS =================

//     /**
//      * Trigger desktop fetch when pagination, filters, or sort changes
//      */
//     useEffect(() => {
//         console.log('💻 [EFFECT] Desktop dependencies changed');
//         if (!isSmallScreen) {
//             fetchDataDesktop();
//         }
//     }, [paginationModel.page, paginationModel.pageSize, filterModel, sortModel, isSmallScreen, fetchDataDesktop]);

//     /**
//      * Trigger mobile fetch when pagination changes
//      */
//     useEffect(() => {
//         console.log('📱 [EFFECT] Mobile pagination changed:', mobilePaginationModel);
//         if (isSmallScreen) {
//             fetchDataMobile();
//         }
//     }, [mobilePaginationModel.page, mobilePaginationModel.pageSize, isSmallScreen, debouncedMobileSearch, fetchDataMobile]);

//     /**
//      * Debounce mobile search and trigger fetch
//      */
//     useEffect(() => {
//         console.log('⏱️ [DEBOUNCE] Starting 400ms timeout for:', mobileSearchQuery);

//         const timer = setTimeout(() => {
//             console.log('⏱️ [DEBOUNCE] Timer completed! Setting search to:', mobileSearchQuery);
//             setDebouncedMobileSearch(mobileSearchQuery);
//             setMobilePaginationModel({ page: 0, pageSize: 20 });
//         }, 400);

//         return () => {
//             console.log('⏱️ [DEBOUNCE] Cleared timeout');
//             clearTimeout(timer);
//         };
//     }, [mobileSearchQuery]);

//     // ================= HANDLERS =================

//     const handleDelete = async () => {
//         const ids = selectedIdsRef.current;
//         if (!ids.length) return;

//         try {
//             const response = await axios.post(`${path}/group/Delete`, { userId, companyId, objAryId: ids });
//             setSnackbar({ open: true, message: 'Deleted successfully.', severity: 'success' });

//             setSelectionModel([]);
//             selectedIdsRef.current = [];
//             setSelectAll(false);

//             if (isSmallScreen) {
//                 fetchDataMobile();
//             } else {
//                 fetchDataDesktop();
//             }
//         } catch (error) {
//             const status = error.response?.status;
//             const data = error.response?.data;
//             if (status === 400 && data?.referencedIds?.length > 0) {
//                 setSnackbar({ open: true, message: "Cannot delete the selected item(s) because they are referenced in other records.", severity: "warning" });
//             } else if (status === 400 && data?.error) {
//                 setSnackbar({ open: true, message: data.error, severity: "warning" });
//             } else {
//                 setSnackbar({ open: true, message: "Delete failed due to an unexpected error.", severity: "error" });
//             }
//         } finally {
//             setConfirmOpen(false);
//         }
//     };

//     const funExportData = () => {
//         axios({ url: `${path}/group/search?mode=export&userId=${userId}&companyId=${companyId}`, method: 'GET', responseType: 'blob', })
//             .then((response) => {
//                 const url = window.URL.createObjectURL(new Blob([response.data]));
//                 const link = document.createElement('a');
//                 link.href = url;
//                 link.setAttribute('download', 'exportedFileProductGroup.xlsx');
//                 document.body.appendChild(link);
//                 link.click();
//                 document.body.removeChild(link);
//             })
//             .catch((error) => {
//                 console.error('Export error:', error);
//                 setSnackbar({ open: true, message: 'Export failed.', severity: 'error' });
//             });
//     };

//     const toggleSelectAll = () => {
//         if (selectAll) {
//             setSelectionModel([]);
//             selectedIdsRef.current = [];
//             setSelectAll(false);
//         } else {
//             const allIds = rows.map(row => row.ProdGRPID);
//             setSelectionModel(allIds);
//             selectedIdsRef.current = allIds;
//             setSelectAll(true);
//         }
//     };

//     // ================= COLUMNS =================

//     const columns = [
//         { field: 'GroupName', headerName: 'Group Name', flex: 1, minWidth: 150,
//             renderCell: (params) => (
//                 <Typography sx={{ cursor: 'pointer', color: 'primary.main', textDecoration: 'underline' }}
//                     onClick={(e) => {
//                         e.stopPropagation();
//                         setEditingId(params.row.ProdGRPID);
//                         setOpenDialog(true);
//                     }}
//                 >
//                     {params.value}
//                 </Typography>
//             )
//         },
//         { field: 'GroupCode', headerName: 'Group Code', flex: 0.7, minWidth: 120 },
//         { field: 'IsPrimary', headerName: 'Primary', flex: 0.5, minWidth: 80, valueFormatter: (value) => (value === 1 ? 'True' : 'False'), filterable: false },
//         { field: 'UnderGRPName', headerName: 'Under Group', flex: 1, minWidth: 150 },
//     ];

//     if (role !== "User") {
//         columns.push({
//             field: 'actions',
//             headerName: 'Actions',
//             width: 120,
//             sortable: false,
//             filterable: false,
//             renderCell: (params) => {
//                 const isRowSelected = selectionModel.includes(params.row.ProdGRPID);
//                 return (
//                     <Box>
//                         <Tooltip title={isRowSelected ? "Delete selected" : "Select this row to enable delete"}>
//                             <span>
//                                 <IconButton color="error" disabled={!isRowSelected}
//                                     onClick={(e) => {
//                                         e.stopPropagation();
//                                         const idsToDelete = selectedIdsRef.current.length > 0 ? selectedIdsRef.current : [params.row.ProdGRPID];
//                                         setPendingDeleteIds(idsToDelete);
//                                         setConfirmOpen(true);
//                                     }}
//                                 >
//                                     <DeleteIcon fontSize="small" />
//                                 </IconButton>
//                             </span>
//                         </Tooltip>
//                     </Box>
//                 );
//             }
//         });
//     }

//     // ================= MOBILE CARD RENDERING =================

//     const renderMobileCards = () => {
//         if (loading) {
//             return (
//                 <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
//                     <CircularProgress />
//                 </Box>
//             );
//         }

//         if (rows.length === 0) {
//             return <CustomNoDataOverlay />;
//         }

//         return (
//             <>
//                 {rows.map((row) => {
//                     const isSelected = selectionModel.includes(row.ProdGRPID);

//                     return (
//                         <Box key={row.ProdGRPID} sx={{ mb: 1.5, p: 2, borderRadius: 2, boxShadow: 2, borderLeft: '4px solid', borderLeftColor: 'primary.main', backgroundColor: '#fff' }} >
//                             <Box>
//                                 <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
//                                     <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
//                                         {role !== 'User' && (
//                                             <Checkbox size="small" checked={isSelected}
//                                                 onChange={() => {
//                                                     const updated = isSelected ? selectionModel.filter(id => id !== row.ProdGRPID) : [...selectionModel, row.ProdGRPID];
//                                                     setSelectionModel(updated);
//                                                     selectedIdsRef.current = updated;
//                                                 }}
//                                             />
//                                         )}

//                                         <Typography fontWeight={600}
//                                             sx={{ color: 'primary.main', textDecoration: 'underline', cursor: 'pointer', fontSize: '1rem' }}
//                                             onClick={(e) => {
//                                                 e.stopPropagation(); // 🔥 important (prevents card click conflict)
//                                                 setEditingId(row.ProdGRPID);
//                                                 setOpenDialog(true);
//                                             }}
//                                         >
//                                             {row.GroupName || '—'}
//                                         </Typography>
//                                     </Box>

//                                     <Chip label={row.UnderGRPName || 'N/A'} size="small" sx={{ fontSize: '0.75rem', height: 24, bgcolor: row.IsPrimary === 1 ? 'primary.main' + '20' : 'grey.200', color: row.IsPrimary === 1 ? 'primary.main' : 'text.secondary', border: '1px solid', borderColor: row.IsPrimary === 1 ? 'primary.main' : 'divider' }} />
//                                 </Box>

//                                 <Divider sx={{ my: 1.5 }} />

//                                 <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                                     <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.875rem' }}>
//                                         Code: <strong>{row.GroupCode || '—'}</strong>
//                                     </Typography>

//                                     <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                         <CheckCircleIcon fontSize="small" sx={{ color: row.IsPrimary === 1 ? 'primary.main' : 'text.disabled', mr: 0.5 }} />
//                                         <Typography variant="body2" sx={{ fontSize: '0.875rem', color: row.IsPrimary === 1 ? 'primary.main' : 'text.secondary', fontWeight: row.IsPrimary === 1 ? 600 : 400 }} >
//                                             {row.IsPrimary === 1 ? 'Primary' : 'Non-Primary'}
//                                         </Typography>
//                                     </Box>
//                                 </Box>
//                             </Box>
//                         </Box>
//                     );
//                 })}

//                 <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, py: 2 }}>
//                     <Button variant="outlined" disabled={mobilePaginationModel.page === 0} onClick={() => setMobilePaginationModel((p) => ({ ...p, page: Math.max(0, p.page - 1) }))} >
//                         ← Previous
//                     </Button>

//                     <Typography variant="body2">
//                         Page {mobilePaginationModel.page + 1} of {Math.ceil(totalCount / mobilePaginationModel.pageSize) || 1}
//                     </Typography>

//                     <Button variant="outlined" disabled={(mobilePaginationModel.page + 1) * mobilePaginationModel.pageSize >= totalCount} onClick={() => setMobilePaginationModel((p) => ({ ...p, page: p.page + 1 }))} >
//                         Next →
//                     </Button>
//                 </Box>
//             </>
//         );
//     };

//     // ================= RENDER =================

//     return (
//         <Box>
//             <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2, gap: 1 }}>
//                 <Button startIcon={<FaFileExcel />} variant="outlined" onClick={funExportData} color="success">
//                     Export
//                 </Button>
//                 <Button startIcon={<AddIcon />} variant="contained" onClick={() => {
//                     setEditingId(null);
//                     setOpenDialog(true);
//                 }}>
//                     Add Product Group
//                 </Button>
//             </Box>

//             <Box sx={{ mb: 2 }}>
//                 <Typography variant="h5" sx={{ fontSize: { xs: '1.25rem', sm: '1.5rem' }, fontWeight: 600 }}>
//                     {isSmallDevice ? "Product Group" : ""}
//                 </Typography>
//             </Box>

//             {rows.length === 0 ? (
//                 <NoDataComponent />
//             ) : isSmallScreen ? (
//                 <>
//                     <Box sx={{ mt: 1, mb: 2, px: 1 }}>
//                         <TextField fullWidth size="small" placeholder="Search groups..." value={mobileSearchQuery} onChange={(e) => setMobileSearchQuery(e.target.value)} variant="outlined"
//                             InputProps={{
//                                 startAdornment: (
//                                     <InputAdornment position="start">
//                                         <SearchIcon />
//                                     </InputAdornment>
//                                 ),
//                             }}
//                         />
//                     </Box>

//                     {role !== 'User' && selectionModel.length > 0 && (
//                         <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5, mb: 2, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 1 }} >
//                             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                 <Checkbox checked={selectAll} onChange={toggleSelectAll} size="small" />
//                                 <Typography variant="body2" sx={{ ml: 1 }}>
//                                     {selectionModel.length} selected
//                                 </Typography>
//                             </Box>
//                             <Tooltip title="Delete selected">
//                                 <IconButton onClick={(e) => {
//                                     e.stopPropagation();
//                                     e.preventDefault();
//                                     setPendingDeleteIds(selectionModel);
//                                     setConfirmOpen(true);
//                                 }} color="error">
//                                     <DeleteIcon />
//                                 </IconButton>
//                             </Tooltip>
//                         </Box>
//                     )}

//                     <Box>{renderMobileCards()}</Box>
//                 </>
//             ) : (
//                 <Box sx={{ height: 400 }}>
//                     {rows?.length === 0 && !isFiltered ? (
//                         <NoDataComponent />
//                     ) : (
//                         <CommonServerDataGrid data={rows} columns={columns} getRowId={(row) => row.ProdGRPID} role={role} pageSizeOptions={[25, 50, 100]} selectionModel={selectionModel} onSelectionModelChange={setSelectionModel} onPageChange={({ page, pageSize }) => { setPaginationModel({ page, pageSize }); }} onFilterChange={setFilterModel} onSortChange={setSortModel} rowCount={totalCount} onFilterStatusChange={setIsFiltered} />
//                     )}
//                 </Box>
//             )}

//             <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} >
//                 <Alert severity={snackbar.severity} variant="filled">
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>

//             <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)} maxWidth="xs" fullWidth>
//                 <DialogTitle>Confirm Deletion</DialogTitle>
//                 <DialogContent>
//                     <Typography variant="body2">
//                         Are you sure you want to delete <strong>{pendingDeleteIds.length}</strong> product group record(s)?
//                     </Typography>
//                 </DialogContent>
//                 <DialogActions>
//                     <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>
//                     <Button color="error" variant="contained" onClick={handleDelete}>Delete</Button>
//                 </DialogActions>
//             </Dialog>
//             <Dialog open={openDialog} maxWidth="sm" fullWidth>
//                 <DialogContent>
//                     <ProGroupMaster mode={editingId ? "edit" : "add"} id={editingId} connectionString={connectionString} companyId={companyId} onPopupCancel={() => setOpenDialog(false)}
//                         onSaved={() => {
//                             setOpenDialog(false);

//                             // 🔥 refresh list
//                             if (isSmallScreen) {
//                                 fetchDataMobile();
//                             } else {
//                                 fetchDataDesktop();
//                             }
//                         }}
//                     />
//                 </DialogContent>
//             </Dialog>
//         </Box>
//     );
// };

// export default ProdGroupDetail2;







import { useState, useEffect, useCallback, useRef } from 'react';
import {
    Box, Button, Card, CardContent, Avatar, Chip, Divider, Paper,
    CircularProgress, LinearProgress, IconButton, Tooltip, Dialog, Snackbar, Alert,
    DialogContent, Typography, Checkbox, InputAdornment,
    TextField
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SearchIcon from '@mui/icons-material/Search';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import CustomNoDataOverlay from '../components/CustomNoDataOverlay';
import NoDataComponent from '../components/NoDataComponent';
import { useTheme, useMediaQuery } from '@mui/material';
import CommonServerDataGrid from '../components/datagridComponent';
import { formatRows } from '../utils/formatRows';
import { FaFileExcel } from 'react-icons/fa';
import ProGroupMaster from './ProGroupMaster';
import { APPBAR_HEIGHT } from '../utils/theme';

function stringToColor(string) {
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    const colors = ['#e74c3c', '#3498db', '#2ecc71', '#e67e22', '#9b59b6', '#1abc9c', '#3f51b5', '#e91e63', '#795548', '#00bcd4'];
    return colors[Math.abs(hash) % colors.length];
}
function getInitials(name) {
    if (!name) return 'G';
    return name.trim().charAt(0).toUpperCase();
}

const ProdGroupDetail2 = ({ connectionString, companyId: companyIdProp, mode, setMode }) => {
    const { user, selectedCompany } = useAuth();
    const userId = user?.UserId || null;
    // Use prop companyId if provided, else fall back to selectedCompany
    const companyId = companyIdProp || selectedCompany?.CompId || null;
    const role = user?.UserCategory;
    const path = `${connectionString}/api`;

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
    const isSmallDevice = useMediaQuery(theme.breakpoints.down(500));

    // ================= STATE =================

    const [rows, setRows] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [selectionModel, setSelectionModel] = useState([]);
    const [loading, setLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
    const [selectAll, setSelectAll] = useState(false);
    const [isFiltered, setIsFiltered] = useState(false);

    // Desktop state
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 });
    const [filterModel, setFilterModel] = useState({ items: [] });
    const [sortModel, setSortModel] = useState([]);

    // Mobile state
    const [mobileSearchQuery, setMobileSearchQuery] = useState('');
    const [debouncedMobileSearch, setDebouncedMobileSearch] = useState('');
    const [mobilePaginationModel, setMobilePaginationModel] = useState({ page: 0, pageSize: 20 });

    // Dialog state
    const [openDialog, setOpenDialog] = useState(false);
    const [editingId, setEditingId] = useState(null);

    // Delete confirmation state
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [pendingDeleteIds, setPendingDeleteIds] = useState([]);
    const [deleting, setDeleting] = useState(false);
    const selectedIdsRef = useRef([]);

    // ================= PARAMETER BUILDERS =================

    const buildMobileParams = (pageNum, searchText) => {
        const offset = pageNum * 20;
        const params = { mode: 'search', userId, companyId, offset, limit: 20 };
        if (searchText && searchText.trim()) {
            params.search = searchText;
        }
        console.log('📦 buildMobileParams:', params);
        return params;
    };

    const buildDesktopParams = (pageNum, pageSize) => {
        const offset = pageNum * pageSize;
        const params = { mode: 'search', userId, companyId, offset, limit: pageSize };

        filterModel.items.forEach(item => {
            if (item.value) {
                switch (item.field) {
                    case 'GroupName':   params.GroupName = item.value; break;
                    case 'GroupCode':   params.GroupCode = item.value; break;
                    case 'IsPrimary':   params.IsPrimary = item.value; break;
                    case 'UnderGRPName': params.UnderGRP = item.value; break;
                    default: break;
                }
            }
        });

        if (sortModel.length > 0) {
            const sort = sortModel[0];
            params.orderBy = `${sort.field} ${sort.sort.toUpperCase()}`;
        }

        console.log('🖥️ buildDesktopParams:', params);
        return params;
    };

    // ================= FETCH FUNCTIONS =================

    const fetchDataDesktop = useCallback(async () => {
        if (isSmallScreen) return;

        console.log('🖥️ [DESKTOP] Fetching data...');
        setLoading(true);
        try {
            const params = buildDesktopParams(paginationModel.page, paginationModel.pageSize);

            const dataRes = await axios.get(`${path}/group/search`, { params });
            const fetchedRows = Array.isArray(dataRes.data) ? dataRes.data : [];
            setRows(formatRows(fetchedRows));
            setSelectionModel([]);
            selectedIdsRef.current = [];
            console.log(`🖥️ Fetched ${fetchedRows.length} rows`);

            const countParams = { ...params };
            delete countParams.mode;
            delete countParams.offset;
            delete countParams.limit;
            delete countParams.orderBy;
            delete countParams.userId;

            const countRes = await axios.get(`${path}/group/count`, { params: countParams });
            const count = Number(countRes.data) || 0;
            setTotalCount(count);
            console.log(`🖥️ Total count: ${count}`);
        } catch (err) {
            console.error('🖥️ Fetch error:', err);
            setSnackbar({ open: true, message: 'Failed to fetch data.', severity: 'error' });
            setRows([]);
            setTotalCount(0);
        } finally {
            setLoading(false);
        }
    }, [path, userId, companyId, paginationModel, filterModel, sortModel, isSmallScreen]);

    const fetchDataMobile = useCallback(async () => {
        console.log('📱 [MOBILE] Fetching data...');
        if (!isSmallScreen) {
            console.log('📱 Skipping - not small screen');
            return;
        }

        setLoading(true);
        try {
            const params = buildMobileParams(mobilePaginationModel.page, debouncedMobileSearch);
            console.log('📱 API URL:', `${path}/group/search`);
            console.log('📱 Params:', JSON.stringify(params, null, 2));

            const dataRes = await axios.get(`${path}/group/search`, { params });
            const fetchedRows = Array.isArray(dataRes.data) ? dataRes.data : [];
            setRows(formatRows(fetchedRows));
            setSelectionModel([]);
            selectedIdsRef.current = [];
            console.log(`📱 Fetched ${fetchedRows.length} rows`);

            const countParams = { ...params };
            delete countParams.mode;
            delete countParams.offset;
            delete countParams.limit;
            delete countParams.userId;

            console.log('📱 Count params:', countParams);
            const countRes = await axios.get(`${path}/group/count`, { params: countParams });
            const count = Number(countRes.data) || 0;
            setTotalCount(count);
            console.log(`📱 Total count: ${count}`);
        } catch (err) {
            console.error('📱 Fetch error:', err);
            console.error('📱 Error response:', err.response?.data);
            setSnackbar({ open: true, message: `Error: ${err.message}`, severity: 'error' });
            setRows([]);
            setTotalCount(0);
        } finally {
            setLoading(false);
        }
    }, [path, userId, companyId, mobilePaginationModel, debouncedMobileSearch, isSmallScreen]);

    // ================= EFFECTS =================

    // Desktop fetch trigger
    useEffect(() => {
        console.log('💻 [EFFECT] Desktop dependencies changed');
        if (!isSmallScreen) {
            fetchDataDesktop();
        }
    }, [paginationModel.page, paginationModel.pageSize, filterModel, sortModel, isSmallScreen, fetchDataDesktop]);

    // Mobile fetch trigger on pagination/search change
    useEffect(() => {
        console.log('📱 [EFFECT] Mobile pagination changed:', mobilePaginationModel);
        if (isSmallScreen) {
            fetchDataMobile();
        }
    }, [mobilePaginationModel.page, mobilePaginationModel.pageSize, isSmallScreen, debouncedMobileSearch]);

    // Debounce mobile search — resets to page 0 on new search
    useEffect(() => {
        console.log('⏱️ [DEBOUNCE] Starting 400ms timeout for:', mobileSearchQuery);
        const timer = setTimeout(() => {
            console.log('⏱️ [DEBOUNCE] Timer completed! Setting search to:', mobileSearchQuery);
            setDebouncedMobileSearch(mobileSearchQuery);
            setMobilePaginationModel({ page: 0, pageSize: 20 });
        }, 400);
        return () => {
            console.log('⏱️ [DEBOUNCE] Cleared timeout');
            clearTimeout(timer);
        };
    }, [mobileSearchQuery]);

    // ================= HANDLERS =================

    const handleDelete = async () => {
        const ids = selectedIdsRef.current;
        if (!ids.length || deleting) return;

        setDeleting(true);
        try {
            await axios.post(`${path}/group/Delete`, { userId, companyId, objAryId: ids });
            setSnackbar({ open: true, message: 'Deleted successfully.', severity: 'success' });
            setSelectionModel([]);
            selectedIdsRef.current = [];
            setSelectAll(false);

            if (isSmallScreen) {
                fetchDataMobile();
            } else {
                fetchDataDesktop();
            }
        } catch (error) {
            const status = error.response?.status;
            const data = error.response?.data;
            if (status === 400 && data?.referencedIds?.length > 0) {
                setSnackbar({ open: true, message: "Cannot delete the selected item(s) because they are referenced in other records.", severity: "warning" });
            } else if (status === 400 && data?.error) {
                setSnackbar({ open: true, message: data.error, severity: "warning" });
            } else {
                setSnackbar({ open: true, message: "Delete failed due to an unexpected error.", severity: "error" });
            }
        } finally {
            setDeleting(false);
            setConfirmOpen(false);
        }
    };

    const funExportData = () => {
        axios({ url: `${path}/group/search?mode=export&userId=${userId}&companyId=${companyId}`, method: 'GET', responseType: 'blob' })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'exportedFileProductGroup.xlsx');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .catch((error) => {
                console.error('Export error:', error);
                setSnackbar({ open: true, message: 'Export failed.', severity: 'error' });
            });
    };

    const toggleSelectAll = () => {
        if (selectAll) {
            setSelectionModel([]);
            selectedIdsRef.current = [];
            setSelectAll(false);
        } else {
            const allIds = rows.map(row => row.ProdGRPID);
            setSelectionModel(allIds);
            selectedIdsRef.current = allIds;
            setSelectAll(true);
        }
    };

    // ================= COLUMNS =================

    const columns = [
        {
            field: 'GroupName', headerName: 'Group Name', flex: 1, minWidth: 150,
            renderCell: (params) => (
                <Tooltip title={params.value || ''} placement="top">
                    <Typography
                        sx={{ cursor: 'pointer', color: 'primary.main', textDecoration: 'underline', fontSize: '0.85rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '100%' }}
                        onClick={(e) => {
                            e.stopPropagation();
                            setEditingId(params.row.ProdGRPID);
                            setOpenDialog(true);
                        }}
                    >
                        {params.value}
                    </Typography>
                </Tooltip>
            )
        },
        {
            field: 'GroupCode', headerName: 'Group Code', flex: 0.7, minWidth: 120,
            renderCell: (params) => (
                <Typography sx={{ fontSize: '0.85rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '100%' }}>
                    {params.value || '—'}
                </Typography>
            )
        },
        {
            field: 'IsPrimary', headerName: 'Primary', flex: 0.5, minWidth: 80,
            valueFormatter: (value) => (value === 1 ? 'True' : 'False'),
            filterable: false
        },
        {
            field: 'UnderGRPName', headerName: 'Under Group', flex: 1, minWidth: 150,
            renderCell: (params) => (
                <Tooltip title={params.value || ''} placement="top">
                    <Typography sx={{ fontSize: '0.85rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '100%' }}>
                        {params.value || '—'}
                    </Typography>
                </Tooltip>
            )
        },
    ];

    if (role !== "User") {
        columns.push({
            field: 'actions', headerName: 'Actions', width: 100,
            sortable: false, filterable: false, headerAlign: 'right', align: 'right',
            renderCell: (params) => {
                const isRowSelected = selectionModel.includes(params.row.ProdGRPID);
                return (
                    <Tooltip title={isRowSelected ? "Delete selected" : "Select row to enable"}>
                        <span>
                            <IconButton color="error" disabled={!isRowSelected}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    selectedIdsRef.current = selectionModel; // 🔥 SYNC
                                    setPendingDeleteIds(selectionModel);
                                    setConfirmOpen(true);
                                }}
                            >
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </span>
                    </Tooltip>
                );
            }
        });
    }

    // ================= MOBILE CARD RENDERING =================

    const renderMobileCards = () => {
        if (loading) {
            return (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4 }}>
                    <CircularProgress />
                </Box>
            );
        }

        if (rows.length === 0) {
            return (
                <Box sx={{ p: 4, textAlign: 'center' }}>
                    <Typography sx={{ color: 'text.secondary', mb: 2 }}>
                        {mobileSearchQuery ? <CustomNoDataOverlay /> : <NoDataComponent />}
                    </Typography>
                    <Typography sx={{ color: 'text.secondary', fontSize: '0.85rem' }}>
                        Search: "{debouncedMobileSearch}" | Page: {mobilePaginationModel.page} | Total: {totalCount}
                    </Typography>
                </Box>
            );
        }

        return (
            <>
                {rows.map((row) => {
                    const isSelected = selectionModel.includes(row.ProdGRPID);

                    const toggleSelection = (e) => {
                        e.stopPropagation();
                        setSelectionModel(prev => {
                            const updated = prev.includes(row.ProdGRPID)
                                ? prev.filter(id => id !== row.ProdGRPID)
                                : [...prev, row.ProdGRPID];
                            selectedIdsRef.current = updated; // 🔥 freeze
                            return updated;
                        });
                    };

                    return (
                        (() => {
                            const avatarColor = stringToColor(row.GroupName || 'G');
                            const initials = getInitials(row.GroupName);
                            return (
                                <Card key={row.ProdGRPID} sx={{ mb: 1.5, borderRadius: 2, boxShadow: 1, overflow: 'hidden', transition: '0.2s', '&:hover': { boxShadow: 3 } }}>
                                    <Box sx={{ height: 5, background: `linear-gradient(90deg, ${avatarColor} 0%, ${avatarColor}88 100%)` }} />
                                    <CardContent sx={{ py: 1.5, px: 1.5 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
                                            {role !== 'User' && (
                                                <Checkbox size="small" checked={isSelected} onChange={toggleSelection} onClick={(e) => e.stopPropagation()} sx={{ p: 0.5, mr: 0.5, flexShrink: 0 }} />
                                            )}
                                            <Avatar sx={{ bgcolor: avatarColor, color: '#fff', width: 38, height: 38, fontWeight: 700, mr: 1.5, flexShrink: 0, fontSize: '1rem' }}>
                                                {initials}
                                            </Avatar>
                                            <Box sx={{ minWidth: 0 }}>
                                                <Typography sx={{ fontWeight: 700, fontSize: '0.95rem', color: '#1976d2', cursor: 'pointer', textDecoration: 'underline' }}
                                                    onClick={(e) => { e.stopPropagation(); setEditingId(row.ProdGRPID); setOpenDialog(true); }}>
                                                    {row.GroupName || '—'}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Divider sx={{ my: 0.8 }} />
                                        <Box sx={{ mt: 0.8, display: 'flex', gap: 0.8, flexWrap: 'wrap', alignItems: 'center' }}>
                                            {row.UnderGRPName && <Chip variant="outlined" label={row.UnderGRPName} size="small" sx={{ height: 22, fontSize: '0.75rem' }} />}
                                            {row.GroupCode && <Chip variant="outlined" label={`Code: ${row.GroupCode}`} size="small" sx={{ height: 22, fontSize: '0.75rem' }} />}
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <CheckCircleIcon fontSize="small" sx={{ color: row.IsPrimary === 1 ? 'primary.main' : 'text.disabled', mr: 0.5 }} />
                                                <Typography variant="caption" sx={{ color: row.IsPrimary === 1 ? 'primary.main' : 'text.secondary', fontWeight: row.IsPrimary === 1 ? 600 : 400 }}>
                                                    {row.IsPrimary === 1 ? 'Primary' : 'Non-Primary'}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </CardContent>
                                </Card>
                            );
                        })()
                    );
                })}

                {/* Mobile Pagination */}
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, py: 2, mt: 2 }}>
                    <Button variant="outlined" size="small" startIcon={<NavigateBeforeIcon />} disabled={mobilePaginationModel.page === 0} onClick={() => setMobilePaginationModel(p => ({ ...p, page: Math.max(0, p.page - 1) }))}>
                        Previous
                    </Button>
                    <Typography variant="body2" sx={{ minWidth: '150px', textAlign: 'center' }}>
                        Page {mobilePaginationModel.page + 1} of {Math.ceil(totalCount / mobilePaginationModel.pageSize) || 1}
                    </Typography>
                    <Button variant="outlined" size="small" endIcon={<NavigateNextIcon />} disabled={(mobilePaginationModel.page + 1) * mobilePaginationModel.pageSize >= totalCount} onClick={() => setMobilePaginationModel(p => ({ ...p, page: p.page + 1 }))}>
                        Next
                    </Button>
                </Box>
            </>
        );
    };

    // ================= RENDER =================

    return (
        <Box sx={{ pt: 0.7, px: 0, display: 'flex', flexDirection: 'column', height: `calc(79vh - ${APPBAR_HEIGHT}px)` }}>

            {/* ── Module Header ──────────────────────────────────────────────
                Blue gradient strip at the top gives every module a consistent
                branded look. The Paper below it holds the title and action
                buttons in one unified bar.
            ────────────────────────────────────────────────────────────────── */}
            <Box sx={{ mb: 2 }}>
                {/* Thin blue gradient strip — visual top border for the header */}
                <Box sx={{ height: 4, background: 'linear-gradient(90deg, #1976d2 0%, #42a5f5 100%)', borderRadius: '6px 6px 0 0' }} />

                {/* Header bar: module title on the left, action buttons on the right */}
                <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderTop: 0, borderRadius: '0 0 8px 8px', px: 2, py: 1.2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography variant="h6" fontWeight={700} color="primary.main" sx={{ fontSize: '1.05rem' }}>
                        Product Groups
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        {/* Export to Excel button */}
                        <Tooltip title="Export to Excel">
                            {/* <Button startIcon={<FaFileExcel />} variant="outlined" onClick={funExportData} color="success" size="small">
                                Export
                            </Button> */}
                        </Tooltip>
                        {/* Open the Add Product Group dialog */}
                        <Button startIcon={<AddIcon />} variant="contained" size="small"
                            onClick={() => {
                                setEditingId(null);
                                setOpenDialog(true);
                            }}
                        >
                            {isSmallDevice ? 'Add' : 'Add Product Group'}
                        </Button>
                    </Box>
                </Paper>
            </Box>

            {/* Content */}
            <Paper elevation={3} sx={{ borderRadius: 2, overflow: 'hidden', flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0, mb: '12px' }}>
                <Box sx={{ p: { xs: 0.5, md: 0.5 }, display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
                    {/* Mobile Search */}
                    {isSmallScreen && (
                        <Box sx={{ mb: 2, px: 1 }}>
                            <TextField fullWidth size="small" placeholder="Search groups..." value={mobileSearchQuery} onChange={(e) => setMobileSearchQuery(e.target.value)} variant="outlined"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Box>
                    )}

                    {/* Bulk Action Bar - Mobile Only */}
                    {isSmallScreen && role !== 'User' && selectionModel.length > 0 && (
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5, mb: 2, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Checkbox checked={selectAll} onChange={toggleSelectAll} size="small" />
                                <Typography variant="body2" sx={{ ml: 1 }}>
                                    {selectionModel.length} selected
                                </Typography>
                            </Box>
                            <Tooltip title="Delete selected">
                                <IconButton color="error"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        selectedIdsRef.current = selectionModel; // 🔥 SYNC
                                        setPendingDeleteIds(selectionModel);
                                        setConfirmOpen(true);
                                    }}
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    )}

                    {/* Mobile View */}
                    {isSmallScreen ? (
                        <Box sx={{ width: '100%', overflowX: 'hidden', px: 1, flex: 1, overflowY: 'auto' }}>
                            {renderMobileCards()}
                        </Box>
                    ) : (
                        /* Desktop View */
                        <Box sx={{ flex: 1, width: '100%', minHeight: 0 }}>
                            {rows?.length === 0 && !isFiltered ? (
                                <NoDataComponent />
                            ) : (
                                <CommonServerDataGrid data={rows} columns={columns} getRowId={(row) => row.ProdGRPID} role={role} pageSizeOptions={[25, 50, 100]} selectionModel={selectionModel} onSelectionModelChange={setSelectionModel} onPageChange={({ page, pageSize }) => setPaginationModel({ page, pageSize })} onFilterChange={setFilterModel} onSortChange={setSortModel} rowCount={totalCount} onFilterStatusChange={setIsFiltered} />
                            )}
                        </Box>
                    )}
                </Box>
            </Paper>

            {/* Snackbar */}
            <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                <Alert severity={snackbar.severity} variant="filled">
                    {snackbar.message}
                </Alert>
            </Snackbar>

            {/* ── Delete Confirmation Dialog ──────────────────────────────────
                Red gradient strip signals danger. The user sees how many
                records will be deleted and must confirm before anything is
                removed from the database.
            ────────────────────────────────────────────────────────────────── */}
            <Dialog open={confirmOpen} onClose={() => { if (!deleting) setConfirmOpen(false); }} maxWidth="xs" fullWidth>
                {/* Red gradient strip at the top — danger indicator */}
                {deleting
                    ? <LinearProgress color="error" sx={{ height: 4 }} />
                    : <Box sx={{ height: 4, background: 'linear-gradient(90deg, #d32f2f 0%, #f44336 100%)' }} />}

                {/* Dialog title */}
                <Box sx={{ px: 2.5, pt: 2, pb: 1.5 }}>
                    <Typography variant="h6" fontWeight={700} sx={{ color: 'error.main', fontSize: '1.05rem' }}>
                        Confirm Deletion
                    </Typography>
                </Box>
                <Divider />

                {/* Warning message: shows the count of records to be deleted */}
                <Box sx={{ px: 2.5, py: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                        Are you sure you want to delete{' '}
                        <Typography component="span" variant="body2" fontWeight={700} color="error.main">
                            {pendingDeleteIds.length}
                        </Typography>
                        {' '}product group record(s)? This action cannot be undone.
                    </Typography>
                </Box>
                <Divider />

                {/* Action buttons: Cancel keeps data safe; Delete confirms removal */}
                <Box sx={{ px: 2.5, py: 1.5, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button onClick={() => setConfirmOpen(false)} variant="outlined" color="inherit" size="small" disabled={deleting}>Cancel</Button>
                    <Button color="error" variant="contained" size="small" disabled={deleting}
                        startIcon={deleting ? <CircularProgress size={14} color="inherit" /> : <DeleteIcon />}
                        onClick={handleDelete}>{deleting ? 'Deleting…' : 'Delete'}</Button>
                </Box>
            </Dialog>

            {/* Add / Edit Dialog */}
            <Dialog open={openDialog} maxWidth="sm" fullWidth>
                <DialogContent>
                    <ProGroupMaster mode={editingId ? "edit" : "add"} id={editingId} connectionString={connectionString} companyId={companyId} onPopupCancel={() => setOpenDialog(false)}
                        onSaved={() => {
                            setOpenDialog(false);
                            if (isSmallScreen) {
                                fetchDataMobile();
                            } else {
                                fetchDataDesktop();
                            }
                        }}
                    />
                </DialogContent>
            </Dialog>
        </Box>
    );
};

export default ProdGroupDetail2;